import { logFirebaseAnalyticsEvent } from "../firebaseAnalytics";
import { getConsent } from "./consentStore";
import { APP_CONFIG } from "../constants";
import { sanitizeTelemetry } from "./telemetryPrivacy";
import { getFirstTouch } from "./firstTouch";

// Centralized list of GA4 / Growth events
export const ANALYTICS_EVENTS = {
    VISITOR_LANDED: "visitor_landed",
    SIGNUP_STARTED: "signup_started",
    SIGNUP_COMPLETED: "signup_completed",
    EMAIL_VERIFIED: "email_verified",
    ONBOARDING_BRAND_SELECTED: "onboarding_brand_selected",
    CATALOG_BRAND_FILTER_APPLIED: "catalog_brand_filter_applied",
    FIRST_MODEL_ADDED: "first_model_added",
    FIRST_COLLECTION_CREATED: "first_collection_created",
} as const;

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];

/**
 * Tracks an analytics event safely.
 * KVKK: Consent yoksa sessizce çıkar — hiçbir veri gönderilmez.
 */
export const trackEvent = (eventName: AnalyticsEventName, params?: Record<string, any>) => {
    try {
        // KVKK guard — analytics izni yoksa event gönderme
        if (!getConsent().analytics) return;

        const cleanParams = sanitizeTelemetry(params);
        // 1. Firebase Web Analytics is loaded only after consent and off the startup path.
        void logFirebaseAnalyticsEvent(eventName, cleanParams);

        // First-party growth reporting. The same endpoint is available to
        // native clients, while WebView/mobile-web traffic is detected here.
        const firstTouch = getFirstTouch();
        const token = localStorage.getItem(APP_CONFIG.STORAGE_KEYS.TOKEN);
        void fetch(`${APP_CONFIG.API_URL}/api/UserEvents/track`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            },
            body: JSON.stringify({
                eventName,
                sessionId: firstTouch?.sessionId,
                source: firstTouch?.source,
                properties: {
                    ...cleanParams,
                    platform: firstTouch?.platform || "Web",
                    landingPage: firstTouch?.landingPage
                }
            }),
            keepalive: true
        }).catch(() => undefined);

        // Optional explicit debug mode for local analytics inspection
        if ((window as any).CH_ANALYTICS_DEBUG) {
            console.log(`[Analytics Event] ${eventName}:`, cleanParams || "No parameters");
        }
    } catch (error) {
        console.warn("[Analytics Warning] Event tracking failed silently:", error);
    }
};
